 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import XHTMLCOVER from '@/components/xhtml/cover'
 import XHTMLFRONT_01 from '@/components/xhtml/front_01'
 import XHTMLAUTHOR from '@/components/xhtml/author'
 import XHTMLTITLE from '@/components/xhtml/title'
 import XHTMLCOPYRIGHT from '@/components/xhtml/copyright'
 import XHTMLTOC from '@/components/xhtml/toc'
 import XHTMLLIST_OF_PLATES from '@/components/xhtml/list_of_plates'
 import XHTMLLIST_OF_MAPS from '@/components/xhtml/list_of_maps'
 import XHTMLPREFACE from '@/components/xhtml/preface'
 import XHTMLACKNOWLEDGEMENTS from '@/components/xhtml/acknowledgements'
 import XHTMLNAMING from '@/components/xhtml/naming'
 import XHTMLFRONT_02 from '@/components/xhtml/front_02'
 import XHTMLPROLOGUE from '@/components/xhtml/prologue'
 import XHTMLCHAPTER_01 from '@/components/xhtml/chapter_01'
 import XHTMLCHAPTER_02 from '@/components/xhtml/chapter_02'
 import XHTMLCHAPTER_03 from '@/components/xhtml/chapter_03'
 import XHTMLCHAPTER_04 from '@/components/xhtml/chapter_04'
 import XHTMLCHAPTER_05 from '@/components/xhtml/chapter_05'
 import XHTMLCHAPTER_06 from '@/components/xhtml/chapter_06'
 import XHTMLCHAPTER_07 from '@/components/xhtml/chapter_07'
 import XHTMLCHAPTER_08 from '@/components/xhtml/chapter_08'
 import XHTMLCHAPTER_09 from '@/components/xhtml/chapter_09'
 import XHTMLCHAPTER_10 from '@/components/xhtml/chapter_10'
 import XHTMLCHAPTER_11 from '@/components/xhtml/chapter_11'
 import XHTMLCHAPTER_12 from '@/components/xhtml/chapter_12'
 import XHTMLCHAPTER_13 from '@/components/xhtml/chapter_13'
 import XHTMLCHAPTER_14 from '@/components/xhtml/chapter_14'
 import XHTMLCHAPTER_15 from '@/components/xhtml/chapter_15'
 import XHTMLCHAPTER_16 from '@/components/xhtml/chapter_16'
 import XHTMLCHAPTER_17 from '@/components/xhtml/chapter_17'
 import XHTMLAPPENDIX_01 from '@/components/xhtml/appendix_01'
 import XHTMLAPPENDIX_02 from '@/components/xhtml/appendix_02'
 import XHTMLAPPENDIX_03 from '@/components/xhtml/appendix_03'
 import XHTMLAPPENDIX_04 from '@/components/xhtml/appendix_04'
 import XHTMLAPPENDIX_05 from '@/components/xhtml/appendix_05'
 import XHTMLAPPENDIX_06 from '@/components/xhtml/appendix_06'
 import XHTMLAPPENDIX_07 from '@/components/xhtml/appendix_07'
 import XHTMLAPPENDIX_08 from '@/components/xhtml/appendix_08'
 import XHTMLBIBLIOGRAPHY from '@/components/xhtml/bibliography'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/xhtml/toc",
 			"name" : "xhtml/toc",
 			"component" : XHTMLTOC
 		},
 		{
 			"path" : "/xhtml/list_of_plates",
 			"name" : "xhtml/list_of_plates",
 			"component" : XHTMLLIST_OF_PLATES
 		},
 		{
 			"path" : "/xhtml/list_of_maps",
 			"name" : "xhtml/list_of_maps",
 			"component" : XHTMLLIST_OF_MAPS
 		},
 		{
 			"path" : "/xhtml/preface",
 			"name" : "xhtml/preface",
 			"component" : XHTMLPREFACE
 		},
 		{
 			"path" : "/xhtml/acknowledgements",
 			"name" : "xhtml/acknowledgements",
 			"component" : XHTMLACKNOWLEDGEMENTS
 		},
 		{
 			"path" : "/xhtml/naming",
 			"name" : "xhtml/naming",
 			"component" : XHTMLNAMING
 		},
 		{
 			"path" : "/xhtml/front_02",
 			"name" : "xhtml/front_02",
 			"component" : XHTMLFRONT_02
 		},
 		{
 			"path" : "/xhtml/prologue",
 			"name" : "xhtml/prologue",
 			"component" : XHTMLPROLOGUE
 		},
 		{
 			"path" : "/xhtml/chapter_01",
 			"name" : "xhtml/chapter_01",
 			"component" : XHTMLCHAPTER_01
 		},
 		{
 			"path" : "/xhtml/chapter_02",
 			"name" : "xhtml/chapter_02",
 			"component" : XHTMLCHAPTER_02
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js